import { LinkableEntityType } from '@api';
import { LinkableEntity } from '@common';
import { Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'TABLE.TOUR_REPS';

type TicketSalesTourRepsCellPropsType = {
  tourProd: LinkableEntityType | null;
  tourRep: LinkableEntityType | null;
  tourAcc: LinkableEntityType | null;
};

type TourRepLinePropsType = {
  label: string;
  entity: LinkableEntityType | null;
  placeholder: string;
};

const TourRepLine: React.FC<TourRepLinePropsType> = ({
  label,
  entity,
  placeholder,
}) => (
  <Group gap="xs" wrap="nowrap">
    <Text>{label}:</Text>
    {entity ? (
      <LinkableEntity linkableEntity={entity} />
    ) : (
      <Text>{placeholder}</Text>
    )}
  </Group>
);

export const TicketSalesTourRepsCell: React.FC<
  TicketSalesTourRepsCellPropsType
> = ({ tourProd, tourRep, tourAcc }) => {
  const { t } = useTranslation('ticketSales');
  const placeholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return (
    <Stack gap={0}>
      <TourRepLine
        label={t(`${TRANS_PATH}.TOUR_PROD`)}
        entity={tourProd}
        placeholder={placeholder}
      />
      <TourRepLine
        label={t(`${TRANS_PATH}.TOUR_REP`)}
        entity={tourRep}
        placeholder={placeholder}
      />
      <TourRepLine
        label={t(`${TRANS_PATH}.TOUR_ACC`)}
        entity={tourAcc}
        placeholder={placeholder}
      />
    </Stack>
  );
};
